import React, { useEffect, useState } from 'react';
import { useData } from '../../../hooks/useData';
import { useToast } from '../../../hooks/useToast';
import { usersDesignationServices } from '../../../APIServices/usersDesignationServices';
import Swal from 'sweetalert2';
import Pagination from '../../../hooks/Pagination';

function DeletedDesignatonHistory({
  getUserDesignationData,
  setModalOpen,
  deletedPageNumber,
  setDeletedPageNumber,
  deletedItemsPerPage,
  setDeletedItemsPerPage,
  setDeleteDesignationList,
  deleteDesignationList,
  setDeleteDesignationCount,
  deleteDesignationCount,
  getDeletedUserDesignationData,
  category
}) {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [designation, setDesignation] = useState("");

  const startIndex = (deletedPageNumber - 1) * deletedItemsPerPage;
  const totalPage = Math.ceil(deleteDesignationCount / deletedItemsPerPage);

  const softDeleteRestoreUserDesignation = async (id) => {
    setButtonLoader(false);
    let userData = {};
    userData.id = id;
    userData.type = "restore";
    let data = await usersDesignationServices.softDeleteRestoreUserDesignation(
      userData
    );
    if (data?.statusCode === 200) {
      getUserDesignationData();
      getDeletedUserDesignationData();
      setModalOpen("");
    }
    setButtonLoader(true);
  }

  useEffect(() => {
    getDeletedUserDesignationData();
  }, [deletedPageNumber, deletedItemsPerPage, category]);

  return (
    <div
      className="modal-backdrop"
      onClick={() =>
        setModalOpen("")
      }
    >
      <div
        className="modal"
        style={{ maxWidth: 480 }}
        onClick={(e) =>
          e.stopPropagation()
        }
      >
        <div className="modal-head">
          <div>
            <div className="modal-title">
              Deleted Designation List
            </div>

            <div className="xs muted">
              Restore and Permanent Designation Delete
            </div>
          </div>

          <button
            className="icon-btn"
            onClick={() =>
              setModalOpen("")
            }
          >
            <i className="ti ti-x" />
          </button>
        </div>

        <div className="modal-body">
          <table className="tbl">
            <thead>
              <tr>
                <th>Designation</th>
                <th style={{ width: 120 }}>
                  Restore
                </th>
              </tr>
            </thead>
            <tbody>
              {deleteDesignationList.map((item) => (
                <tr key={item.id}>
                  <td className="medium">
                    {item.designation}
                  </td>
                  <td>
                    <div className="flex gap-2">
                      <button
                        className="icon-btn"
                        title="Restore"
                        style={{
                          color:
                            'var(--info)',
                        }}
                        onClick={() => softDeleteRestoreUserDesignation(item?._id)}
                      >
                        <i className="ti ti-rotate" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <Pagination
            itemsPerPage={deletedItemsPerPage}
            setItemsPerPage={setDeletedItemsPerPage}
            pageNumber={deletedPageNumber}
            setPageNumber={setDeletedPageNumber}
            totalPage={totalPage}
            totalItems={deleteDesignationCount}
          />
        </div>
      </div>
    </div>
  );
}

export default DeletedDesignatonHistory;